import React, { useState } from "react";
import style from "./PromptModalStyle";
import { generateImprovedPrompt } from "../../../../Services/agentService";
import toast from "react-hot-toast";

export default function PromptModal({ agent, onClose, onSave }) {
  const [editedPrompt, setEditedPrompt] = useState(agent.prompt || "");
  const [userRequest, setUserRequest] = useState("");
  const [generatedPrompt, setGeneratedPrompt] = useState("");
  const [isGenerating, setIsGenerating] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async () => {
    setIsSaving(true);
    await onSave(agent, editedPrompt);
    setIsSaving(false);
  };

  const handleGenerate = async () => {
    if (!userRequest.trim()) {
      toast.error("Descreva o que você quer melhorar no prompt!");
      return;
    }
    setIsGenerating(true);
    setGeneratedPrompt("");
    try {
      const data = {
        currentPrompt: editedPrompt,
        userRequest: userRequest,
      };
      const response = await generateImprovedPrompt(data);
      setGeneratedPrompt(response.generatedPrompt);
      toast.success("Prompt gerado pela IA!");
    } catch (error) {
      toast.error(error.response?.data?.message || "Falha ao gerar prompt.");
    } finally {
      setIsGenerating(false);
    }
  };

  const handleUseGeneratedPrompt = () => {
    setEditedPrompt(generatedPrompt);
    setGeneratedPrompt("");
    toast.success("Prompt aplicado ao editor!");
  };

  if (!agent) return null;

  return (
    <div style={style.modalOverlay} onClick={onClose}>
      <div style={style.modalContent} onClick={(e) => e.stopPropagation()}>
        <div style={style.modalHeader}>
          <div>
            <h3 style={style.modalTitle}>Editar Prompt do Agente</h3>
            <p style={style.cardSubtext}>{agent.name} | WhatsApp: {agent.realWhatsappNumber}</p>
          </div>
          <button style={style.modalCloseButton} onClick={onClose}>&times;</button>
        </div>
        <div style={style.modalBody}>
          <div style={style.editorContainer}>
            <label style={style.label}>Editor de Prompt</label>
            <textarea
              style={style.promptTextarea}
              value={editedPrompt}
              onChange={(e) => setEditedPrompt(e.target.value)}
              placeholder="Insira o prompt principal aqui..."
            />
          </div>
          <div style={style.aiContainer}>
            <label style={style.label}>Melhorar com IA</label>
            <textarea
              style={{...style.promptTextarea, minHeight: '100px'}}
              value={userRequest}
              onChange={(e) => setUserRequest(e.target.value)}
              placeholder="Descreva aqui as mudanças ou a nova empresa. Ex: 'Adapte este prompt para a empresa 'TecVendas', que vende software de CRM. Mude o tom para ser mais direto e foque em agendar uma demonstração.'"
            />
            <button style={style.generateButton} onClick={handleGenerate} disabled={isGenerating}>
              {isGenerating ? "Gerando..." : "Gerar Prompt com IA"}
            </button>
            {generatedPrompt && (
              <div style={style.resultContainer}>
                <label style={style.label}>Resultado da IA:</label>
                <textarea
                  style={{...style.promptTextarea, backgroundColor: '#010409'}}
                  value={generatedPrompt}
                  readOnly
                />
                <button style={style.usePromptButton} onClick={handleUseGeneratedPrompt}>
                  Usar este Prompt
                </button>
              </div>
            )}
          </div>
        </div>
        <div style={style.modalFooter}>
          <button style={{...style.actionButton, ...style.cancelButton}} onClick={onClose} disabled={isSaving}>
            Cancelar
          </button>
          <button style={{...style.actionButton, ...style.saveButton}} onClick={handleSave} disabled={isSaving}>
            {isSaving ? "Salvando..." : "Salvar Alterações"}
          </button>
        </div>
      </div>
    </div>
  );
}